import { FaUserShield, FaLaptopCode, FaStar, FaHeadset } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const WhyChooseUs = () => {
  const { t } = useTranslation();
  const cards = [
    {
      icon: <FaUserShield className="w-[28px] h-[28px] lg:w-[40px] lg:h-[40px]" />,
      title: t("whychoose.Reliable Team"),
      description: t("whychoose.Reliable Team description"),
      bgColor: "bg-white",
      textColor: "text-primary",
      border: "border border-gray-300",
    },
    {
      icon: <FaLaptopCode className="w-[28px] h-[28px] lg:w-[40px] lg:h-[40px]" />,
      title: t("whychoose.Personalized Service"),
      description: t("whychoose.Personalized description"),
      
    },
    {
      icon: <FaStar className="w-[28px] h-[28px] lg:w-[40px] lg:h-[40px]" />,
      title: t("whychoose.Flawless Results"),
      description: t("whychoose.Flawless Results description"),
     
    },
    {
      icon: <FaHeadset className="w-[28px] h-[28px] lg:w-[40px] lg:h-[40px]" />,
      title: t("whychoose.Exceptional Support"),
      description: t("whychoose.Exceptional Support description"),
      
    },
  ];

  return (
    <section id="why" className="py-6 w-screen lg:py-16">
      <div className="w-full px-[14px] lg:px-20 xl:px-30 2xl:px-60 text-center">
        <h2 className="text-[22px] lg:text-[32px] font-bold text-textTitle mb-4">
          {t("whychoose.title")}
        </h2>
        <p className="text-textSubtitle mb-12 lg:mb-20 font-medium text-[12px] lg:text-[14px] leading-[20px] lg:leading-[28px] text-justify">
        {t("whychoose.description")}
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-[10px] gap-y-12 lg:gap-8 ">
          {cards.map((card, index) => (
            <div
              key={index}
              className={`text-textPrimary hover:border-bgPrimary hover:text-white relative pt-2 lg:pt10 p-1 lg:p-4 rounded-lg shadow-md border border-bgPrimary bg-white hover:bg-bgPrimary transition-transform transform hover:scale-105`}
            >
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60px] h-[60px] lg:w-[80px] lg:h-[80px] rounded-full flex justify-center items-center shadow-md bg-white border border-gray-200 ">
                <span className="text-textPrimary">{card.icon}</span>
              </div>

              <h3 className={`text-[12px] lg:text-[14px] font-bold mt-10 mb-2`}>
                {card.title}
              </h3>
              <p className="text-[10px] lg:text-[12px] mb-1">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
